import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export function useScrollToHash() {
  const location = useLocation()

  useEffect(() => {
    // Get the scroll container (Home page uses a custom scroll container)
    const scrollContainer = document.getElementById('home-scroll-container')

    if (location.hash) {
      // Small delay to ensure the element is rendered
      setTimeout(() => {
        const element = document.querySelector(location.hash)
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          })
        }
      }, 100)
    } else if (location.pathname === '/') {
      // Scroll to top when navigating to home without hash
      if (scrollContainer) {
        scrollContainer.scrollTo({ top: 0, behavior: 'smooth' })
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      }
    }
  }, [location])
}
